import React, { useState } from "react";
import { Form, Button, Modal, Image } from "react-bootstrap";
import { TextField } from "@material-ui/core";
//import { sendSmsAdmin } from "../../../../store/actions/AdminSms&Notification/message_notification";
import { send_sms_diner } from "../../../store/actions/notificationAction/notificationActions";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const SendSmsNew = (props) => {
  const [showSMS, seShowSMS] = useState(false);
  const handleCloseSMS = () => seShowSMS(false);
  const handleShowSMS = () => seShowSMS(true);
  const formik = useFormik({
    initialValues: {
      message: "",
    },
    validationSchema: yup.object({
      message: yup
        .string()
        .max(256, "Must be 256 characters or less")
        .required("Please enter Message"),
    }),
    onSubmit: (values) => {
      const onErrorrSms = () => {
        handleCloseSMS();
        formik.resetForm();
      };

      const onSuccessSms = () => {
        handleCloseSMS();
        formik.resetForm();
      };

      if (props.mobile_number.length >= 10 || props.mobile_number <= 13) {
        let formData = {};
        // if (props.mobile_number.startsWith("+91")) {
        //   formData.mobile_number = "+91" + props.mobile_number.substring(3);
        // } else {
        //   formData.mobile_number = "+91" + props.mobile_number;
        // }
        formData.message = values.message;
        formData.order_id = props.order_id;
        formData.type = props.type || 3;
        formData.sms = true;
        formData.id = props.id;

        const token = props.auth.user.accessToken;
        props.send_sms_diner(formData, token, onSuccessSms, onErrorrSms);
      } else {
        Alert.error(`<h4> Invalid Mobile No or Mobile No Not Found </h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    },
  });

  return (
    <React.Fragment>
      <Button variant="link" className="enIconBtn mr-3" onClick={handleShowSMS}>
        <Image
          src={require("../../../assets/images/UserManagement/email.svg")}
          alt="SMS"
          title="Send SMS"
          fluid
        />
      </Button>
      <Modal show={showSMS} dialogClassName="model-z-index-1061" className="z-index-1060" onHide={handleCloseSMS} centered>
        <Modal.Header className="py-0 pt-3 border-0" closeButton>
          <Modal.Title className="f24-700">Send SMS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={formik.handleSubmit}>
            <div className="f16-400 pb-3">
              Do you want to send SMS to {props.first_name}
            </div>
            <TextField
              id="outlined-basic"
              label="Add Message"
              variant="outlined"
              multiline
              rows="5"
              className="w-100"
              name="message"
              onChange={formik.handleChange}
              value={formik.values.message}
              onBlur={formik.handleBlur}
              //onInvalid={formik.errors.email && formik.touched.email}
              isInvalid={formik.errors.message && formik.touched.message}
            />
            {formik.errors.message && formik.touched.message ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.message}
              </div>
            ) : null}
            <div className="d-flex align-items-center pt-4">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={handleCloseSMS}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5"
                type="submit"
              //onClick={handleCloseSMS}
              >
                Send
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

SendSmsNew.propTypes = {
  auth: PropTypes.object.isRequired,
  send_sms_diner: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  send_sms_diner,
})(SendSmsNew);
